export default __webpack_public_path__ + "static/media/video-advertise1.76959e92.png";